import { doc, setDoc, serverTimestamp, collection, deleteDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export const savePushToken = async ({ uid, token }) => {
  if (!uid || !token) return;

  const tokensRef = collection(db, "users", uid, "pushTokens");

  const existing = await getDocs(tokensRef);

  for (const docSnap of existing.docs) {
    await deleteDoc(docSnap.ref);
  }

  await setDoc(
    doc(db, "users", uid, "pushTokens", token),
    {
      uid,
      token,
      platform: "web",
      lastActive: serverTimestamp(),
    }
  );
};

